import { Component, OnInit } from '@angular/core';
import { Events } from '@ionic/angular';
import { LOGO_PATH_ONLY_MASCOTTE } from 'src/app/constants';

@Component({
  selector: 'app-thankyou',
  templateUrl: './thankyou.page.html',
  styleUrls: ['./thankyou.page.scss'],
})
export class ThankYouPage implements OnInit {

  logoPath = LOGO_PATH_ONLY_MASCOTTE;

  constructor(
    private events: Events,
  ) { }

  ngOnInit(): void {
    this.events.publish('send:pay:success');
  }
}
